//
// Lookup Item Types
//
export type LookupItemType = {
  code: string
  name: string
}

export type DestinationType = LookupItemType

export type CountryType = LookupItemType

export type CurrencyType = LookupItemType

//
// Functions on top of LookupItems
//

/**
 * Finds lookup item by code in the list of lookups.
 * If no lookup item of given code can be found,
 * the function creates a new LookupItemType with name == code.
 * If null is passed as 'code' argument, this function returns null.
 */
export function getLookupItemByCodeOrNew(
  lookups: LookupItemType[],
  code: string | null
): LookupItemType | null {
  if (code == null) {
    return null
  }
  return (
    // If no item matches, let's create a new one with given code and name == code
    // this should be used when loading pottentially unknown data into the view component
    lookups.find((item: LookupItemType) => item.code === code) ?? {
      code: code,
      name: code,
    }
  )
}
